import script from "./ShowInfoStudyWord.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowInfoStudyWord.vue?vue&type=script&setup=true&lang=js"

import "./ShowInfoStudyWord.vue?vue&type=style&index=0&id=0abf20c1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0abf20c1"]])

export default __exports__